<template>
  <div class="register bg-gradient-ex bg-london">
    <mdb-container>
      <mdb-row class="flex-center" style="min-height: 100vh">
        <mdb-col md="8" xl="4" class="text-center">
          <div class="start-header">
            <img src="../assets/Exsellance_Logo_Transparent_1.png" width="140px" />
          </div>
          <mdb-card class="p-3">
            <mdb-card-body>
              <mdb-card-title class="mb-3 text-center">
                <h1>Register</h1>
              </mdb-card-title>
              <mdb-card-text>
                <div class="text-red mb-5">{{validationMessage}}</div>

                <mdb-input v-model="email" label="Your email" type="email" class="mb-5" />
                <mdb-input v-model="password" label="Your password" type="password" />
                <span class="input--help"></span>

                <div class="terms-checkbox custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="accepted"
                    v-model="accepted"
                  />
                  <label class="custom-control-label ml-1" for="accepted">
                    I am over 16 and I've read and agree to the
                    <span
                      color="primary"
                      class="link"
                      @click="showModal = true"
                    >Subscriber Terms and Conditions</span>,
                    <span
                      color="primary"
                      class="link"
                      @click="showModal1 = true"
                    >Website Terms and Conditions</span> and
                    <span
                      color="primary"
                      class="link"
                      @click="showModal2 = true"
                    >Privacy & Cookie Policy</span>
                  </label>
                </div>
                <div
                  v-if="showWarning"
                  class="accept text-red"
                >Please accept the terms and conditions.</div>
              </mdb-card-text>
              <mdb-card-footer class="text-center mt-3">
                <mdb-btn @click="signup" color="primary">Register</mdb-btn>
                <mdb-btn
                  v-if="false"
                  @click="mthStatsIncrementNewUsers"
                  color="primary"
                >Test NEW USERS stats tester (incrementer)</mdb-btn>
              </mdb-card-footer>
            </mdb-card-body>
          </mdb-card>
          <div class="start-footer">
            <div class="start-footer-top">
              Already have an account?
              <router-link to="/login">
                <mdb-btn>Login</mdb-btn>
              </router-link>
            </div>
            <div class="start-footer-bottom">
              <!-- causes stack overflow -->
              <!-- <router-link to="/help">
                <span>Help</span>
              </router-link>-->
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-modal :show="showModal" @close="showModal = false" scrollable class="terms">
      <mdb-modal-header>
        <mdb-modal-title></mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <h3>SUBSCRIBER TERMS AND CONDITIONS</h3>

        <h5>EXSELLANCE LTD</h5>

        <p>These Conditions, together with any and all other documents referred to herein, set out the terms on which we provide our Services to registered account holders through this Website or by other means. Please read these Conditions carefully and ensure that you understand them before purchasing any Services from us. You will be required to accept them. If you do not agree to comply with and be bound by these Conditions, you will not be able to purchase our Services.</p>

        <p>Use of our Website is subject to our Website Terms of Use. Please ensure that you have read them carefully and that you understand them.</p>

        <p>
          The Website is owned and operated by Exsellance Limited, Registered Number 11762944, (the
          <strong>“Supplier”</strong>) whose registered office is at 20-22 Wenlock Road, London, England, N1 7GU.
        </p>

        <p>All personal information that we may collect from you will be collected, used and held in accordance with our Privacy Policy and your rights under data protection legislation.</p>

        <h4 class="mt-5">AGREED TERMS</h4>

        <ol>
          <li>
            1. Interpretation
            <ol>
              <li>
                1.1.
                <strong>Definitions.</strong> In these Conditions, the following definitions apply:
                <ol>
                  <li>
                    1.1.1.
                    <strong>Business Day:</strong> a day (other than a Saturday, Sunday or public holiday) when banks in London are open for business.
                  </li>
                  <li>
                    1.1.2.
                    <strong>Charges:</strong> the charges payable by the Customer for Services purchased via our Website or App in accordance with clause 5 (“Charges and Payment”) below.
                  </li>
                  <li>
                    1.1.3.
                    <strong>Conditions:</strong> the terms and conditions set out in this document as amended from time to time in accordance with the Conditions.
                  </li>
                  <li>
                    1.1.4.
                    <strong>Contract:</strong> the contract between the Supplier and the Customer for the purchase of Services, incorporating these Conditions and as set out in clause 2.3.
                  </li>
                  <li>
                    1.1.5.
                    <strong>Customer:</strong> the person (Consumer) or firm who purchases Services from the Supplier.
                  </li>
                  <li>
                    1.1.6.
                    <strong>Intellectual Property Rights:</strong> patents, rights to inventions, copyright and related rights, trade marks, business names and domain names, rights in get-up, goodwill and the right to sue for passing off, rights in designs, database rights, rights to use, and protect the confidentiality of, confidential information (including know-how), and all other intellectual property rights, in each case whether registered or unregistered and including all applications and rights to apply for and be granted, renewals or extensions of, and rights to claim priority from, such rights and all similar or equivalent rights or forms of protection which subsist or will subsist now or in the future in any part of the world.
                  </li>
                  <li>
                    1.1.7.
                    <strong>Services:</strong> sales development services, training services and business consulting services, supplied by the Supplier to the Customer as a subscription or as otherwise agreed.
                  </li>
                  <li>
                    1.1.8.
                    <strong>Website:</strong> the website at www.exsellance.com and any associated application the Supplier makes available on which these Conditions also appear.
                  </li>
                </ol>
              </li>

              <li>
                1.2.
                <strong>Construction.</strong> In these Conditions, the following rules apply:
                <ol>
                  <li>
                    1.2.1. a
                    <strong>person</strong> includes a natural person, corporate or unincorporated body (whether or not having separate legal personality);
                  </li>
                  <li>1.2.2. a reference to a party includes its personal representatives, successors and permitted assigns;</li>
                  <li>1.2.3. a reference to a statute or statutory provision is a reference to such statute or statutory provision as amended or re-enacted includes any subordinate legislation made under that statute or statutory provision as amended or re-enacted;</li>
                  <li>1.2.4. any obligation on a party not to do something includes an obligation not to allow that thing to be done;</li>
                  <li>
                    1.2.5. any phrase introduced by the terms
                    <strong>including, include, in particular</strong> or any similar expression, shall be construed as illustrative and shall not limit the sense of the words preceding those terms; and
                  </li>
                  <li>
                    1.2.6. a reference to
                    <strong>writing</strong> or
                    <strong>written</strong> includes e-mails.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            2. Basis of contract
            <ol>
              <li>2.1. Customers may only purchase Services if they are 16 years of age.</li>
              <li>2.2. The Website will guide the Customer through the registration process. The registration constitutes an offer by the Customer to register for, or purchase, Services in accordance with these Conditions.</li>
              <li>2.3. The registration for Services shall only be deemed to be accepted once you complete the registration process for our Services online and agree to these Terms of Business, at which point and on which date the Contract shall come into existence. The Service confirmations will include details of the subscription purchased.</li>
              <li>2.4. The Contract constitutes the entire agreement between the parties in relation to its subject matter. The Customer acknowledges that it has not relied on any statement, promise, representation, assurance or warranty made or given by or on behalf of the Supplier which is not set out in the Contract.</li>
              <li>2.5. Any samples, drawings, descriptive matter or advertising issued by the Supplier, and any descriptions or illustrations contained in the Supplier's promotional materials, are issued or published for the sole purpose of giving an approximate idea of the Services described in them. They shall not form part of the Contract or have any contractual force.</li>
              <li>2.6. These Conditions apply to the Contract to the exclusion of any other terms that the Customer seeks to impose or incorporate, or which are implied by trade, custom, practice or course of dealing.</li>
            </ol>
          </li>

          <li>
            3. Supply of Services
            <ol>
              <li>3.1. The Supplier shall supply the Services to the Customer in accordance with their relevant subscription or purchase in all material respects.</li>
              <li>3.2. The Supplier shall have the right to make any changes to the Services which are necessary to comply with any applicable law or safety requirement, or which do not materially affect the nature or quality of the Services, and the Supplier shall notify the Customer in any such event.</li>
              <li>3.3. The Supplier shall provide the Services using reasonable care and skill.</li>
            </ol>
          </li>

          <li>
            4. Customer's obligations
            <ol>
              <li>
                4.1. The Customer shall:
                <ol>
                  <li>4.1.1. ensure that they agree with the terms of the Services registered for, or purchased online, and any information provided before signing up to use the Services;</li>
                  <li>4.1.2. provide the Supplier with such information as the Supplier may reasonably require to supply the Services, and ensure that such information is accurate and kept up-to-date in all material respects.</li>
                  <li>
                    4.2. If the Supplier's performance of any of its obligations under the Contract is prevented or delayed by any act or omission by the Customer or failure by the Customer to perform any relevant obligation (
                    <strong>“Customer Default”)</strong>:
                  </li>
                  <li>4.2.1. the Supplier shall, without limiting its other rights or remedies, have the right to suspend performance of the Services until the Customer remedies the Customer Default, and shall rely on the Customer Default to relieve it from the performance of any of its obligations to the extent the Customer Default prevents or delays the Supplier's performance of any of its obligations;</li>
                  <li>4.2.2. the Supplier shall not be liable for any costs or losses sustained or incurred by the Customer arising directly or indirectly from the Supplier's failure or delay to perform any of its obligations as set out in this clause; and</li>
                  <li>4.2.3. the Customer shall reimburse the Supplier on written demand for any costs or losses sustained or incurred by the Supplier arising directly or indirectly from the Customer Default.</li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            5. Charges and payment (if applicable)
            <ol>
              <li>5.1. The Charges for the Services shall be as set out on the Website or as otherwise agreed over email at enquiries@exsellance.com.</li>
              <li>5.2. The Charges shall be payable in full and in cleared funds upon registration for the Services. Payment shall be made via credit card, debit card or bank transfer to the bank account nominated by the Supplier.</li>
              <li>
                5.3. Unless otherwise stated, the price of the Services will be inclusive of amounts in respect of value added tax (
                <strong>“VAT”</strong>).
              </li>
              <li>5.4. If the Customer fails to make any payment due to the Supplier under the Contract by the due date for payment, then the Supplier reserves the right to suspend the Services and terminate the Contract and the Customer shall pay interest on the overdue amount at the rate of 4% (four per cent) per annum above Barclays Bank's base rate from time to time. Such interest shall accrue on a daily basis from the due date until actual payment of the overdue amount, whether before or after judgment.</li>
              <li>5.5. The Supplier reserves the right to amend the Charges at any time and to add, alter, or remove special offers from time to time. Changes in price will not affect any Services that a Customer has already purchased but will apply to any future purchases.</li>
            </ol>
          </li>

          <li>
            6. Intellectual property rights
            <ol>
              <li>6.1. All Intellectual Property Rights in or arising out of or in connection with the Website and the Services shall be owned by the Supplier or its licensors. The Supplier shall assert all moral rights arising out of Chapter IV of the Copyright, Designs and Patents Act 1988. Throughout the term of the Contract, the Supplier grants the Customer a limited, royalty-free, non-exclusive, non-sublicensable, non-transferable licence of any and all such rights to the Customer solely to the extent necessary to use the Services, in accordance with these Conditions and the Contract. The Customer shall not sub-license, assign or otherwise transfer the rights granted in this clause.</li>
              <li>6.2. The Customer acknowledges that, in respect of any third party Intellectual Property Rights, the Customer's use of any such Intellectual Property Rights is conditional on the Supplier obtaining a written licence from the relevant licensor on such terms as will entitle the Supplier to license such rights to the Customer.</li>
            </ol>
          </li>
          <li>
            7. Confidentiality
            <ol>
              <li>7.1. Each party (‘receiving party’) shall keep in strict confidence all technical or commercial know-how, specifications, inventions, processes or initiatives which are of a confidential nature and have been disclosed to the receiving party by the other party (‘disclosing party’), its employees, agents or subcontractors, and any other confidential information concerning the disclosing party, its business, its products and services which the receiving party may obtain or which is disclosed to that party by the disclosing party pursuant to or in connection with the Contract (whether orally or in writing or any other medium, and whether or not the information is expressly stated to be confidential or marked as such).</li>
              <li>7.2. The Supplier shall only disclose such confidential information to those of its employees, agents and subcontractors who need to know it for the purpose of discharging its obligations under the Contract, and shall ensure that such employees, agents and subcontractors comply with the obligations set out in this clause as though they were a party to the Contract. The receiving party may also disclose such of the disclosing party's confidential information as is required to be disclosed by law, any governmental or regulatory authority or by a court of competent jurisdiction. This clause shall survive termination of the Contract. The restrictions in this clause shall not apply to any information which is or becomes publicly available otherwise than through a breach of these Conditions, is already or rightly comes into the receiving party’s possession without an accompanying obligation of confidence, or which is independently developed by the receiving company.</li>
            </ol>
          </li>

          <li>
            8. Limitation of liability and indemnity
            <ol>
              <li>
                8.1. Nothing in these Conditions shall limit or exclude the Supplier's (or its employees’, agents’ or subcontractors’) liability for:
                <ol>
                  <li>8.1.1. death or personal injury caused by its negligence, or the negligence of its employees, agents or subcontractors;</li>
                  <li>8.1.2. fraud or fraudulent misrepresentation; or</li>
                  <li>8.1.3. any other liability to the extent such liability may not be excluded or limited as a matter of law.</li>
                </ol>
              </li>
              <li>
                8.2. Subject to the aforesaid:
                <ol>
                  <li>8.2.1. the Supplier shall under no circumstances whatever be liable to the Customer, whether in contract, tort (including negligence), breach of statutory duty or otherwise, for any loss (whether direct or indirect) of actual or anticipated income, savings or profits, contracts, business, business opportunities, revenue, turnover, savings, goodwill, reputation loss or corruption of data or information, or wasted expenditure, or for any indirect or consequential loss arising under or in connection with the Contract; and</li>
                  <li>8.2.2. the Supplier's total liability to the Customer in respect of all other losses arising under or in connection with the Contract, whether in contract, tort (including negligence), breach of statutory duty or otherwise, shall in no circumstances exceed the Charges paid by the Customer to the Supplier in the 6-month period prior to the claim.</li>
                </ol>
              </li>
              <li></li>
              <li>8.3. The terms implied by sections 3 to 5 of the Supply of Goods and Services Act 1982 are, to the fullest extent permitted by law, excluded from the Contract.</li>
              <li>8.4. The Customer shall indemnify the Supplier against any costs, liability, damages, loss, expenses, claims or proceedings arising from loss or damage (including that belonging to any third parties appointed by the Supplier) caused by any breach of these Conditions or any other liabilities arising out of the use of the Website or the Services by the Customer or its agents or employees.</li>
              <li>8.5. This clause shall survive termination of the Contract.</li>
            </ol>
          </li>
          <li>
            9. Customer’s right to make changes
            <ol>
              <li>9.1. If the Customer wishes to make a change to Services ordered, please contact the Supplier at enquiries@exsellance.com. The Supplier will let the Customer know if the change is possible. If it is possible the Supplier will let the Customer know about any changes to the price of the Services or anything else which would be necessary as a result of the Customer’s requested change and ask the Customer to confirm whether the Customer wishes to proceed with the change. If the Supplier cannot implement the change, or the consequences of making the change are unacceptable to the Customer, the Customer may terminate the Contract.</li>
            </ol>
          </li>

          <li>
            10. Termination
            <ol>
              <li>
                10.1. The Customer may end the Contract at any time if:
                <ol>
                  <li>10.1.1. the Customer informs the Supplier of their need to cancel and provides a 10 day notice period; or</li>

                  <li>10.1.2. the Supplier has informed the Customer of a forthcoming change to its Services, or to these Conditions that the Customer does not agree to. If the change is set to take effect or apply before the end of the current Services, the Supplier will issue the Customer with a pro-rated refund equal to the remaining time left for the Services bought. The Customer also has a legal right to end the Contract at any time if the Supplier is in breach of it. The Customer may also be entitled to a full or partial refund and compensation.</li>
                </ol>10.2. Without limiting its other rights or remedies, the Supplier may terminate the Contract at any time by giving the Customer one month’s notice in writing and, unless termination is the fault of the Customer, the Supplier shall refund to the Customer any Charges paid for Services not yet received. The Supplier may suspend provision of the Customer’s Services if the Customer fails to pay any amount due under this Contract on the due date for payment or the Supplier believes that the Customer may be unable to pay its debts as and when they fall due, or if the Customer stops carrying on business or threatens to do so.
              </li>
            </ol>
          </li>
          <li>
            11. Consequences of termination
            <ol>
              <li>
                11.1. On termination of the Contract for any reason:
                <ol>
                  <li>11.1.1. the Customer shall immediately pay to the Supplier any outstanding Charges and interest due;</li>

                  <li>11.1.2. the accrued rights, remedies, obligations and liabilities of the parties as at expiry or termination shall be unaffected, including the right to claim damages in respect of any breach of the Contract which existed at or before the date of termination or expiry; and</li>

                  <li>11.1.3. clauses which expressly or by implication survive termination shall continue in full force and effect.</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            12. Force majeure
            <ol>
              <li>
                12.1. For the purposes of this Contract,
                <strong>Force Majeure Event</strong> means an event beyond the reasonable control of the Supplier including but not limited to strikes, lock-outs or other industrial disputes (whether involving the workforce of the Supplier or any other party), failure of a utility service or transport network, act of God, war, riot, civil commotion, malicious damage, compliance with any law or governmental order, rule, regulation or direction, accident, breakdown of plant or machinery, fire, flood, storm or default of suppliers or subcontractors.
              </li>
              <li>12.2. The Supplier shall not be liable to the Customer as a result of any delay or failure to perform its obligations under this Contract as a result of a Force Majeure Event.</li>
              <li>12.3. If the Force Majeure Event prevents the Supplier from providing any of the Services for more than thirty (30) days, the Supplier shall, without limiting its other rights or remedies, have the right to terminate this Contract immediately by giving written notice to the Customer.</li>
            </ol>
          </li>
          <li>
            13. General
            <ol>
              <li>
                13.1.
                <strong>Assignment and other dealings</strong>
                .
                <ol>
                  <li>13.1.1. The Supplier may at any time assign, transfer, mortgage, charge, subcontract or deal in any other manner with all or any of its rights under the Contract and may subcontract or delegate in any manner any or all of its obligations under the Contract to any third party or agent.</li>

                  <li>13.1.2. The Customer shall not, without the prior written consent of the Supplier, assign, transfer, mortgage, charge, subcontract, declare a trust over or deal in any other manner with any or all of its rights or obligations under the Contract.</li>
                </ol>
              </li>
              <li>
                13.2.
                <strong>Notices</strong>
                .
                <ol>
                  <li>13.2.1. Any notice or other communication given to a party under or in connection with the Contract shall be in writing, addressed to that party at its registered office (if it is a company) or its principal place of business (in any other case) or such other address as that party may have specified to the other party in writing in accordance with this clause, and shall be delivered personally, sent by pre-paid first class post or other next working day delivery service, commercial courier, or email.</li>
                  <li>13.2.2. A notice or other communication shall be deemed to have been received: if delivered personally, when left at the address referred to in clause 13.2 (“Notices”); if sent by pre-paid first class post or other next working day delivery service, at 12.00 pm on the second Business Day after posting; if delivered by commercial courier, on the date and at the time that the courier's delivery receipt is signed; or, if sent by email, one Business Day after transmission.</li>
                  <li>13.2.3. The provisions of this clause shall not apply to the service of any proceedings or other documents in any legal action.</li>
                </ol>
              </li>
              <li>
                13.3.
                <strong>Severance</strong>

                <ol>
                  <li>13.3.1. If any provision or part-provision of the Contract is or becomes invalid, illegal or unenforceable, it shall be deemed modified to the minimum extent necessary to make it valid, legal and enforceable. If such modification is not possible, the relevant provision or part-provision shall be deemed deleted. Any modification to or deletion of a provision or part-provision under this clause shall not affect the validity and enforceability of the rest of the Contract.</li>
                  <li>13.3.2. If any provision or part-provision of this Contract is invalid, illegal or unenforceable, the parties shall negotiate in good faith to amend such provision so that, as amended, it is legal, valid and enforceable, and, to the greatest extent possible, achieves the intended commercial result of the original provision.</li>
                </ol>
              </li>
              <li>
                13.4.
                <strong>Waiver</strong>. A waiver of any right under the Contract or law is only effective if it is in writing and shall not be deemed to be a waiver of any subsequent breach or default. No failure or delay by a party in exercising any right or remedy provided under the Contract or by law shall constitute a waiver of that or any other right or remedy, nor shall it prevent or restrict its further exercise of that or any other right or remedy. No single or partial exercise of such right or remedy shall prevent or restrict the further exercise of that or any other right or remedy.
              </li>
              <li>
                13.5.
                <strong>No partnership or agency</strong>. Nothing in the Contract is intended to, or shall be deemed to, establish any partnership or joint venture between the parties, nor constitute either party the agent of the other for any purpose. Neither party shall have authority to act as agent for, or to bind, the other party in any way.
              </li>
              <li>
                13.6.
                <strong>Third parties</strong>. A person who is not a party to the Contract shall not have any rights to enforce its terms.
              </li>
              <li>
                13.7.
                <strong>Variation</strong>. The Supplier may revise these Conditions from time to time in response to changes in relevant laws and other regulatory requirements. If the Supplier changes these Conditions as they relate to the Customer’s Services, it will give the Customer reasonable advance notice of the changes and provide details of how to cancel if the Customer is not happy with them.
              </li>
              <li>
                13.8.
                <strong>Governing law</strong>. This Contract and any dispute or claim arising out of or in connection with it or its subject matter or formation (including non-contractual disputes or claims), shall be governed by and construed in accordance with the law of England and Wales.
              </li>
              <li>
                13.9.
                <strong>Jurisdiction</strong>. Each party irrevocably agrees that the courts of England and Wales shall have exclusive jurisdiction to settle any dispute or claim arising out of or in connection with this Contract or its subject matter or formation (including non-contractual disputes or claims).
              </li>
            </ol>
          </li>
        </ol>
      </mdb-modal-body>
      <mdb-modal-footer></mdb-modal-footer>
    </mdb-modal>

    <mdb-modal :show="showModal1" @close="showModal1 = false" scrollable class="terms">
      <mdb-modal-header>
        <mdb-modal-title></mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <h3 class="text-uppercase">Website Terms & Conditions</h3>

        <h5>
          In respect of
          Exsellance Ltd
        </h5>

        <p>Welcome to the Exsellance Ltd (11762944) of 20-22 Wenlock Road, London, England, N1 7GU (we/us/our/the Company) website at www.exsellance.com and associated mobile application (the “App”) (together, the "Site"). These terms of use, together with any other documents, policies and terms referred to herein, set out the terms of use under which you may use this Site (the “Terms”). We draw your attention in particular to the Limitation of Liability section.</p>

        <p>Any reference to “you” in these Terms includes yourself and any person that accesses or uses the Site and the services we make available via the Site (the “Services”) on your behalf, whether as a guest or a registered user.</p>

        <p>Please read these Terms carefully before using this Site. By using our Site, you confirm that you accept these Terms and agree to comply with them. Your agreement to comply with and be bound by these Terms is deemed to occur upon your first use of our Site and you will be required to read and accept these terms when signing up for an account). If you do not agree to these Terms, you must not use our Site.</p>

        <ol>
          <li>
            1. Other applicable Terms
            <ol>
              <li>1.1. These Terms incorporate our Privacy & Cookie Policy, which also apply to your use of the Site.</li>

              <li>1.2. Our Privacy Policy sets out the terms on which we collect, process, share and store any personal data we collect from you, or that you provide to us. Our Cookie Policy sets out information about the cookies on our Site. We will only use your personal data as set out in our Privacy & Cookie Policy.</li>

              <li>1.3. If you use our App on an Apple/iOS device the App Store Terms also apply. If you use our App on an Android device the Google Play store Terms also apply.</li>

              <li>1.4. These Terms do not apply to the sale of our subscriptions. If you purchase a subscription from our Site, our Subscriber Terms and Conditions will also apply and are incorporated into these Terms.</li>
            </ol>
          </li>
          <li>2. Information about us Our Site, www.exsellance.com is owned and operated by the Company, which is registered in England and Wales under company number 11762944 and has its registered office at 20-22 Wenlock Road, London, England, N1 7GU. The Company’s VAT number is 314733714.</li>
          <li>3. Changes to these Terms We may revise these Terms at any time by amending this page. Please check this page from time to time for any changes, as they are binding on you upon your first use of the Site after the changes have been introduced. In the event of any conflict between the current version of these Terms and any previous version(s), the provisions that are current and in effect will prevail (unless it is expressly stated otherwise).</li>
          <li>4. Changes to our Site We may update our Site from time to time, and may change the content and Services at any time. However, please note that any of the content on our Site may be out of date at any given time, and we are under no obligation to update it. We do not guarantee that our Site, or any content on it, will be free from errors or omissions.</li>
          <li>
            5. Accessing our Site
            <ol>
              <li>5.1. We do not guarantee that our Services, our Site, or any content on it, will always be available or be uninterrupted. Access to our Site is permitted on an “as is” temporary basis. We may suspend, withdraw, discontinue or change all or any part of our Site or Services without notice. We will not be liable to you if for any reason our Site is unavailable at any time or for any period.</li>

              <li>5.2. You are responsible for making all arrangements necessary for you to have access to our Site.</li>

              <li>5.3. You are also responsible for ensuring that all persons who access our Site through your internet connection are aware of these Terms and other applicable terms and conditions, and that they comply with them.</li>
            </ol>
          </li>
          <li>
            6. Your Account and Password
            <ol>
              <li>6.1. You must be at least 18 years old to use our Site. Any registration by, use of, or access to our Site by under the age of 18 is unauthorised and is in breach of these Terms. In using our Site, you represent and warrant that you are at least 18 years old.</li>

              <li>6.2. When you choose, or you are provided with a password or any other piece of information as part of our security procedures, you must treat such information as confidential. You must not disclose it to any third party.</li>

              <li>6.3. We have the right to disable any password, whether chosen by you or allocated by us, at any time, if in our reasonable opinion you have failed to comply with any of the provisions of these Terms.</li>

              <li>6.4. If you know or suspect that anyone other than you knows your password, you must promptly notify us at enquiries@exsellance.com. We will not be liable for any unauthorised use of your account.</li>

              <li>6.5. You may close your account at any time by contacting us through email at enquiries@exsellance.com</li>
            </ol>
          </li>
          <li>
            7. Intellectual Property Rights and use of material on our Site
            <ol>
              <li>7.1. We are the owner or the licensee of all intellectual property rights on our Site, and in the material published on it. Those works are protected by trademark and copyright laws and treaties around the world. All such rights are reserved and, subject to the below, you may not reproduce, copy, distribute, sell, sub-licence, store, or in any other manner re-use content from our Site unless given express written permission to do so by us.</li>

              <li>7.2. You may print off one copy and may download extracts of any page(s) from our Site for your personal use. You may draw the attention of others within your organisation to content posted on our Site.</li>

              <li>7.3. You must not modify the paper or digital copies of any materials you have printed off or downloaded in any way, and you must not use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text.</li>

              <li>7.4. Our status (and that of any identified contributors) as the authors of content on our Site must always be acknowledged.</li>

              <li>7.5. You must not use any part of the content on our Site for commercial purposes without obtaining a licence to do so from us or our licensors.</li>

              <li>7.6. If you print off, copy or download any part of our Site in breach of these Terms, your right to use our Site will cease immediately and you must, at our option, return or destroy any copies of the materials you have made. You agree that you will not use our intellectual property rights in any way other than allowed under these Terms and any infringement by you thereof will be a material breach of these Terms.</li>

              <li>7.7. Nothing in these Terms grants you any legal rights in the Site other than as necessary to enable you to access the Site. You agree not to adjust, to try to circumvent or delete any notices contained on the Site (including any intellectual property notices) and in particular in any digital rights or other security technology embedded or contained within the Site.</li>
            </ol>
          </li>
          <li>
            8. No reliance on information
            <ol>
              <li>8.1. The content on our Site is provided for general information only. It is not intended to amount to advice on which you should rely. It is your responsibility to ensure that any Services or information available through the Site (either directly or indirectly) meet your specific requirements.</li>

              <li>8.2. Although we make reasonable efforts to update the information on our Site, we make no representations, warranties or guarantees, whether express or implied, that the content on our Site is accurate, complete or up-to-date.</li>
            </ol>
          </li>
          <li>
            9. Limitations of our liability
            <ol>
              <li>9.1. Nothing in these Terms excludes or limits our liability for death or personal injury arising from our negligence, or our fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or limited by English law.</li>

              <li>9.2. To the fullest extent permissible by law, we accept no liability to any user for any loss or damage, whether foreseeable or otherwise, in contract, tort (including negligence), for breach of statutory duty, or otherwise, arising out of or in connection with the use of (or inability to use) our Site and Services or the use of or reliance upon our Services or any content included on our Site. To the fullest extent permitted by law, we exclude all conditions, warranties, representations or other terms which may apply to our Services, Site or any content on it, whether express or implied, including any guarantee that our Site will meet your requirements.</li>

              <li>9.3. We will not be liable to any user for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with:</li>

              <ol>
                <li>9.3.1. use of, or inability to use, our Site;</li>

                <li>9.3.2. use of or reliance on our Services or any content displayed on our Site;</li>

                <li>9.3.3. loss of profits, sales, business, or revenue;</li>

                <li>9.3.4. business interruption;</li>

                <li>9.3.5. loss of anticipated savings;</li>

                <li>9.3.6. loss of business opportunity, goodwill or reputation; or</li>

                <li>9.3.7. any indirect or consequential loss or damage.</li>
              </ol>

              <li>9.4. We will not be liable to you for any loss of profit, loss of business, sales or revenue, business interruption, loss of anticipated savings, or loss of business opportunity, goodwill or reputation, or for any indirect or consequential loss or damage.</li>

              <li>9.5. We will not be liable for any loss or damage caused by a virus, distributed denial-of-service attack, or other technologically harmful material that may infect your computer equipment, computer programs, data or other proprietary material due to your use of our Site or to your downloading of any content on it, or on any website linked to it. We accept no responsibility or liability arising out of any disruption or non-availability of our Site resulting from external causes including, but not limited to, ISP equipment failure, host equipment failure, communications network failure, natural events or acts of war.</li>

              <li>9.6. We assume no responsibility for the content of websites linked on our Site. Unless expressly stated, these websites are not under our control. Such links should not be interpreted as an endorsement by us of those linked websites. We will not be liable for any loss or damage that may arise from your use of them.</li>

              <li>9.7. If you purchase a subscription from our Site, additional limitations and exclusions of liability will apply, which are set out in our Subscriber Terms and Conditions and are hereby incorporated into these Terms.</li>
            </ol>
          </li>
          <li>
            10. Your Content
            <ol>
              <li>10.1. Content that you post using our Services is your content, and includes (but is not limited to) anything you post using our Services such as usernames, profile pictures, photos, descriptions, reviews, comments or videos (“Your Content”). We do not make any claim to Your Content. Your Content must comply with the Content Standards in paragraph 15 below.</li>

              <li>
                10.2.
                <strong>Responsibility for Your Content.</strong> You understand that you are solely responsible for Your Content. You warrant that you have all necessary rights to Your Content and that you are not infringing or violating any third party’s rights by posting it or uploading it to the Site. You agree to indemnify us for any loss or damage suffered by us as a result of your breach of that warranty. This means you will be responsible for any loss or damage we suffer as a result of your breach of warranty.
              </li>

              <li>
                10.3.
                <strong>Permission to Use Your Content.</strong> By posting, submitting or transmitting Your Content on or via our Site, you grant us a licence to use it. We don’t claim any ownership to Your Content, but we have your permission to use it to help us function and grow. That way, we won’t infringe any rights you have in Your Content and we can help promote Your Content and use it to deliver our Services to you.
              </li>

              <li>
                10.4.
                <strong>Rights You Grant to us.</strong> By posting Your Content, you grant us a non-exclusive, worldwide, royalty-free, irrevocable, fully transferable, sub-licensable, perpetual licence to use, display, edit, modify, reproduce, distribute, store, and prepare derivative works of Your Content to operate and promote the Site, in any formats and through any channels, including across any third-party website or advertising medium. Your Content will be considered non-confidential and nonproprietary and we have the right to use, copy, distribute and disclose it to third parties.
              </li>

              <li>
                10.5.
                <strong>Reporting Unauthorized Content.</strong> We take intellectual property rights very seriously, and are committed to following appropriate legal procedures to remove infringing content from our Site. If content that you own or have rights to (including Your Content) has been posted to the Site without your permission and you want it removed, please contact us at enquiries@exsellance.com. If Your Content infringes another person’s intellectual property, we will remove it if we receive proper notice. If any third party claims that any material posted or uploaded by you to the Site violates their intellectual property rights, or their right to privacy, we have the right to disclose your identity to them. We’ll notify you if that happens.
              </li>

              <li>
                10.6.
                <strong>Inappropriate, False or Misleading Content.</strong> There are certain types of content we don’t want posted via the Site (for legal reasons or otherwise). You agree that you will not post any content that is abusive, threatening, defamatory, obscene, vulgar or otherwise offensive or in violation of our Terms (including the Content Standards set out in paragraph 15 below). You also agree not to post any content that is false and misleading or uses the Site in a manner that is fraudulent or deceptive. We will not be responsible, or liable to any third party, for Your Content or the accuracy of any materials posted by you or any other user of the Site.
              </li>
            </ol>
          </li>
          <li>
            11. Submitting Information to the Site
            <ol>
              <li>11.1. While we try to make sure that the Site is secure, we cannot guarantee the security of any information that you supply to us and therefore we cannot guarantee that it will be kept confidential. For that reason, you should not let us have any patentable ideas or patent applications, advertising or marketing suggestions, prototypes, or any other information that you regard as confidential, commercially sensitive, or valuable.</li>
            </ol>
          </li>
          <li>
            12. Viruses
            <ol>
              <li>12.1. We do not guarantee that our Site will be secure or free from bugs or viruses. You are responsible for configuring your information technology, computer programmes and platform in order to access our Site. You should use your own virus protection software.</li>

              <li>12.2. You must not misuse our Site by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful. You must not attempt to gain unauthorised access to our Site, the server on which our Site is stored or any server, computer or database connected to our Site. You must not attack our Site via a denial-of-service attack or a distributed denial-of service attack. A breach of this provision is a criminal offence under the Computer Misuse Act 1990. We will report any such breach to the relevant law enforcement authorities and we will cooperate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use our Site will cease immediately.</li>
            </ol>
          </li>
          <li>
            13. Linking to our Site
            <ol>
              <li>13.1. You may link to our home page, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it.</li>

              <li>13.2. You must not establish a link in such a way as to suggest any form of association, approval or endorsement on our part where none exists.</li>

              <li>13.3. You must not establish a link to our Site in any website that is not owned by you.</li>

              <li>13.4. Our Site must not be framed on any other Site, nor may you create a link to any part of our Site other than the home page.</li>

              <li>13.5. We reserve the right to withdraw linking permission without notice.</li>

              <li>13.6. The website to which you are linking must comply in all respects with the Content Standards paragraph set out below (Content Standards).</li>

              <li>13.7. If you wish to make any use of content on our Site other than that set out above, please contact us at enquiries@exsellance.com.</li>
            </ol>
          </li>
          <li>
            14. Prohibited uses
            <ol>
              <li>
                14.1. You may use our Site only for lawful purposes. You may not use our Site:
                <ol>
                  <li>14.1.1. In any way that breaches any applicable local, national or international law or regulation.</li>

                  <li>14.1.2. In any way that is unlawful or fraudulent, or has any unlawful or fraudulent purpose or effect.</li>

                  <li>14.1.3. For the purpose of harming or attempting to harm minors in any way.</li>

                  <li>14.1.4. To send, knowingly receive, upload, download, use or reuse any material which does not comply with our content standards described in the next paragraph (Content Standards).</li>

                  <li>14.1.5. To transmit, or procure the sending of, any unsolicited or unauthorised advertising or promotional material or any other form of similar solicitation (spam).</li>

                  <li>14.1.6. To knowingly transmit any data, send or upload any material that contains viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware, adware or any other harmful programs or similar computer code designed to adversely affect the operation of any computer software or hardware.</li>
                </ol>
              </li>
              <li>
                14.2. You also agree:
                <ol>
                  <li>14.2.1. Not to reproduce, duplicate, copy or resell any part of our Site in contravention of these Terms.</li>

                  <li>
                    14.2.2. Not to access without authority, interfere with, damage or disrupt:
                    <ol>
                      <li>14.2.2.1. any part of our Site;</li>

                      <li>14.2.2.2. any equipment or network on which our Site is stored;</li>

                      <li>14.2.2.3. any software used in the provision of our Site; or</li>

                      <li>14.2.2.4. any equipment or network or software owned or used by any third party.</li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            15. Content standards
            <ol>
              <li>15.1. These content standards apply to any and all material which you upload or contribute to our Site (contributions). You must comply with the spirit and the letter of the following standards. The standards apply to each part of any contribution as well as to its whole.</li>
              <li>
                15.2. Contributions must:
                <ol>
                  <li>15.2.1. Be accurate (where they state facts).</li>

                  <li>15.2.2. Be genuinely held (where they state opinions).</li>

                  <li>15.2.3. Comply with applicable law in the UK and in any country from which they are posted.</li>
                </ol>
              </li>

              <li>
                15.3. Contributions must not:
                <ol>
                  <li>15.3.1. Contain any material which is defamatory of any person.</li>

                  <li>15.3.2. Contain any material which is obscene, offensive, hateful or inflammatory.</li>

                  <li>15.3.3. Promote sexually explicit material.</li>

                  <li>15.3.4. Promote violence.</li>

                  <li>15.3.5. Promote discrimination based on race, sex, religion, nationality, disability, sexual orientation or age.</li>

                  <li>15.3.6. Infringe any copyright, database right or trademark of any other person.</li>

                  <li>15.3.7. Be likely to deceive any person.</li>

                  <li>15.3.8. Be made in breach of any legal duty owed to a third party, such as a contractual duty or a duty of confidence.</li>
                  <li>15.3.9. Promote any illegal activity.</li>

                  <li>15.3.10. Be threatening, abuse or invade another’s privacy, or cause annoyance, inconvenience or needless anxiety.</li>

                  <li>15.3.11. Be likely to harass, upset, embarrass, alarm or annoy any other person.</li>

                  <li>15.3.12. Be used to impersonate any person, or to misrepresent your identity or affiliation with any person.</li>

                  <li>15.3.13. Give the impression that they emanate from us, if this is not the case.</li>

                  <li>15.3.14. Advocate, promote or assist any unlawful act such as (by way of example only) copyright infringement or computer misuse.</li>
                </ol>
              </li>
              <li>15.4. We are not responsible for the content or accuracy of, or for any opinions, views, or values expressed in any posts, comments or other content posted by users. Any such opinions, views, or values are those of the relevant user and do not reflect our opinions, views, or values in any way.</li>
            </ol>
          </li>
          <li>
            16. Suspension and termination
            <ol>
              <li>
                16.1. We will determine, in our discretion, whether there has been a breach of these Terms. When a breach has occurred, we may take such action as we deem appropriate, including any of the following actions:
                <ol>
                  <li>16.1.1. Immediate, temporary or permanent withdrawal of your right to use our Site (including suspension or termination of your account)</li>

                  <li>16.1.2. Immediate, temporary or permanent removal of any posting or material uploaded by you to our Site.</li>

                  <li>16.1.3. Issue of a warning to you.</li>

                  <li>16.1.4. Legal proceedings against you for reimbursement of all costs on an indemnity basis (including, but not limited to, reasonable administrative and legal costs) resulting from the breach.</li>

                  <li>16.1.5. Further legal action against you.</li>

                  <li>16.1.6. Disclosure of such information to law enforcement authorities as we reasonably feel is necessary.</li>
                </ol>
              </li>

              <li>16.2. We exclude liability for actions taken in response to breaches of these Terms. The responses described in this policy are not limited, and we may take any other action we reasonably deem appropriate.</li>

              <li>16.3. You agree to fully reimburse us for all losses (including loss of profit, revenue, goodwill or reputation), costs and expenses arising out of any breach of these Terms by you, or any other act or omission by you in using the Site or by any other person accessing the Site using your personal information with your authority that results in any legal responsibility on our part to any third party.</li>

              <li>16.4. If your account is terminated or deactivated (by you or by us), your photos, comments and all other data uploaded and pertaining to your account (including Your Content) will no longer be accessible through your account, but those materials and data may persist and appear within the Site (for example if Your Content has been re-shared by other users).</li>

              <li>16.5. We encourage you to maintain your own backup of Your Content. We are not a backup service and you agree that you will not rely on the Site for the purposes of backup or storage of Your Content. Whilst we will take all reasonable steps to keep Your Content secure, we do not guarantee that others will not gain access to your information or that Your Content will be stored safely. You acknowledge that the Internet may be subject to breaches of security and that the submission of content or other information may not be secure.</li>
            </ol>
          </li>
          <li>
            16. Miscellaneous
            <ol>
              <li>16.1. Clause headings are inserted for convenience only and shall not affect the interpretation of these Terms. We will not lose our rights under these Terms by reason of any delay by us in enforcing those rights.</li>

              <li>16.2. If any provision of these Terms is deemed unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from these Terms and shall not affect the validity and enforceability of any remaining provisions.</li>

              <li>16.3. These Terms, and all incorporated documents referred to herein, constitutes the entire agreement as to your use of and our provision of the Site and supersedes and extinguishes all previous agreements, promises, assurances, warranties, representations and understandings between us, whether written or oral.</li>

              <li>16.4. You acknowledge that, in entering into this agreement, you do not rely on, and shall have no remedies in respect of, any statement, representation, assurance or warranty (whether made innocently or negligently) that is not set out in these Terms or any incorporated documents referred to herein.</li>
            </ol>
          </li>
          <li>17. Applicable law These Terms will be interpreted, construed and enforced in all respects in accordance with the laws of England and Wales, and you irrevocably submit to the jurisdiction of the Courts of England and Wales and you irrevocably submit to the exclusive jurisdiction of the Courts of England and Wales, except that if you are a resident of Northern Ireland you may also bring proceedings in Northern Ireland, and if you are a resident of Scotland, you may also bring proceedings in Scotland.</li>
          <li>18. Contact us To contact us, please email enquiries@exsellance.com.</li>
        </ol>

        <p>Thank you for visiting our Site.</p>
      </mdb-modal-body>
      <mdb-modal-footer></mdb-modal-footer>
    </mdb-modal>

    <mdb-modal :show="showModal2" @close="showModal2 = false" scrollable class="terms">
      <mdb-modal-header>
        <mdb-modal-title></mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <h3>Privacy & Cookie Policy</h3>
        <h5>
          In respect of
          Exsellance Ltd
        </h5>

        <h4>Privacy</h4>

        <p>Exsellance Ltd is committed to protecting and respecting your privacy.</p>

        <p>
          Personal data, or personal information, means any information about an individual from which that person can be
          identified. It does not include data where the identity has been removed (anonymous data). This policy sets out the
          basis on which any personal data we collect from you, or that you provide to us will be processed, stored and
          disclosed by us. Please read the following carefully to understand our views and practices regarding your personal
          data and how we will treat it. By visiting www.exsellance.com (the Site) or using Exsellance Ltd’s mobile
          application (the App) or using any services offered through or associated with our Site or App (the Services), you
          are deemed to have accepted and consented to the practices described in this policy.
        </p>

        <p>
          The Site is owned and operated by Exsellance Ltd (11762944) of 20-22 Wenlock Road, London, England, N1 7GU (our
          Company Address).
        </p>

        <p>
          Exsellance Ltd processes personal data as a Data Controller , as defined in the Directive and the General Data
          Protection Regulation (GDPR). Exsellance Ltd has a Data Protection Officer who is responsible for matters relating
          to privacy and data protection. This Data Protection Officer is Jananan Sriskanthan and they can be reached at 20-22
          Wenlock Road, London, England, N1 7GU or at enquiries@exsellance.com.
        </p>

        <p>
          The Site contains links to and from the websites of our partner networks, advertisers and affiliates or to websites
          shared by other users. If you follow a link to any of these websites, please note that these websites have their own
          privacy policies and that we do not accept any responsibility or liability for these policies. Please check these
          policies before you submit any personal data to these websites.
        </p>

        <h5>1. Data We Collect About You</h5>

        <p>
          We collect and process personal information so we can provide our Services to you. It’s important that the
          personal data we hold about you is accurate and current. Please keep us informed if your personal data changes
          during your relationship with us.
        </p>

        <p>The data we collect and process about you is explained in the sections below.</p>

        <ol>
          <li>
            1. Data You Give Us
            <ol>
              <li>
                1.1. You give us information about you by filling in forms on our Site or App or by corresponding
                with us by phone, email or otherwise. This includes information you provide when you register to use
                the Site or App, request a quote, subscribe to our marketing database, subscribe to our services,
                search for a product or service, participate in discussion boards or other social media functions on
                our Site or App, promotion or survey, report a problem with the Site.
              </li>

              <li>
                1.2.The information you give us includes names, address, email address or login details, phone
                number, non-specific age, business information, financial and credit card information, personal
                identification number(s), personal description and characteristics (including photographs), spatial
                data (location data), behavioural data, family and spousal data, education history, purchase
                history, financial transaction history, real estate information (including title number), asset
                information (internet protocol or media access control), race, gender, sexual orientation, and
                employment information.
              </li>

              <li>
                1.3.We rely upon implied and express consent, as this data is necessary for our legitimate interests
                and for us to fulfill our contractual obligations to you, and we rely on this as a lawful basis to
                use and process the data described above.
              </li>
            </ol>
          </li>

          <li>
            1.2. Data We Automatically Collect
            <ol>
              <li>
                1.2.1.Each time you visit or use our Site, we automatically collect the following information:
                <ol>
                  <li>
                    1.2.1.1.
                    <strong>technical information</strong>
                    , including the Internet protocol (IP) address used
                    to connect your computer to the Internet, your login information, browser type and version, time
                    zone setting, location, network data, browser plug-in types and versions, languages, operating
                    system and platform;
                  </li>
                  <li>
                    1.2.1.2.
                    <strong>information about your visit</strong>, including the full Uniform Resource Locators
                    (URL) clickstream to, through and from the Site (including date and time); pages you viewed or
                    searched for; page response times, download errors, length of visits to certain pages, page
                    interaction information (such as scrolling, clicks, and mouse-overs), and methods used to browse
                    away from the page and any phone number used to call our customer service number.
                  </li>
                </ol>
              </li>
              <li>
                1.2.2. We rely upon implied and express consent, as this data is necessary for us to fulfil our contractual
                obligations to you, and we rely on this as a lawful basis to use and process the data described above.
              </li>
            </ol>
          </li>
        </ol>

        <h5>2. How We Use Your Data</h5>

        <ol>
          <li>
            2.1. We use your data to carry out our Site, App and Services in the following ways:
            <ol>
              <li>
                2.1.1. To administer and manage your account, to provide you with information you request from us, and to carry out any
                other obligations arising from any contracts entered into between you and us.
              </li>

              <li>2.1.2. To ensure that content from our Site and App is presented in the most effective manner for you and for your</li>device.
              <li>2.1.3. To allow you to participate in interactive features of our Service when you choose to do so.</li>

              <li>2.1.4. To advertise additional services of ours to you.</li>

              <li>
                2.1.5. To respond to communications from you and to provide you with information about our Services, including
                notifying you about changes to our Site, App or Services.
              </li>
            </ol>
          </li>

          <li>
            2.2. We also use your data to make our Site, App and Services better in the following ways:
            <ol>
              <li>
                2.2.1. To administer the Site and App and for internal operations, including troubleshooting, data analysis, testing,
                research, statistical and survey purposes.
              </li>

              <li>
                2.2.2. As part of our efforts to keep the Site and App safe and secure, e.g. by conducting analysis required to detect
                malicious data and understand how this may affect your IT system.
              </li>
            </ol>
          </li>
          <li>
            2.3. We will not send you any unsolicited marketing or spam and will take all reasonable steps to ensure that we
            fully protect your rights and comply with our obligations under applicable data protection laws. If you are an
            existing customer, we will only contact you by electronic means (email or SMS) with information about services
            similar to those which were the subject of a previous enquiry by you. If you are a new customer, and where we
            permit selected third parties to use your data, we (or they) will contact you by electronic means only if you
            have expressly consented to this.
          </li>

          <li>
            2.4. You can ask us or third parties to stop sending you marketing messages at any time by logging into the Site or
            App and checking or unchecking relevant boxes to adjust your marketing preferences or by following the opt-out
            links on any marketing message sent to you or by contacting us at any time. If you do not want us to use your
            data in this way, or to pass your details on to third parties for marketing purposes, please notify us in
            writing or by email at enquiries@ exsellance.com.
          </li>
        </ol>

        <h5>3. How We Secure Your Data</h5>

        <ol>
          <li>
            3.1. All of your personal information is protected and we have put in place appropriate physical, electronic, and
            management procedures to safeguard and secure the data we collect. Your information is stored on secure cloud
            databases, internal servers, and on third party software. We also make use of Google hosting to further protect
            your information. Your information is only accessible by employees or contractors who have authorised access
            rights to such information. All of your payment information is encrypted using SSL technology.
          </li>

          <li>
            3.2. Unfortunately, the transmission of information via the internet is not completely secure. Although we do our
            best to protect your personal data, we cannot guarantee the security of your data transmitted to our Site or
            App; any transmission is at your own risk. Once we have received your information, we use strict procedures and
            the security features described above to try to prevent unauthorised access.
          </li>
        </ol>

        <h5>4. How Long We Store Your Data.</h5>

        <p>
          We only keep your personal information for as long as it’s necessary for our original legitimate purpose
          for collecting the information and for as long as we have your permission to keep it. We will delete
          your personal information when you contact our Data Protection Officer through the given contact details
          above and ask us to delete your information.
        </p>

        <h5>5. Disclosure to Third Parties</h5>

        <ol>
          <li>
            5.1. Parties with whom we share your information
            <ol>
              <li>
                5.1.1. We require all third parties to respect the security of your personal data and to treat it in accordance
                with the law. We use third parties such as Google and Amazon for the safekeeping of your personal data.
                These third parties have access to data we share with their platforms.
              </li>

              <li>
                5.1.2. The only other circumstances under which we would share your personal data are:
                <ol>
                  <li>
                    5.1.2.1. If the third party is a member of our group (which means any subsidiaries or ultimate holding company and
                    its subsidiaries, as defined in section 1159 of the UK Companies Act 2006).
                  </li>

                  <li>
                    5.1.2.2. In the event that we sell or buy any business or assets, in which case we may disclose your personal data to
                    the prospective seller or buyer of such business or assets.
                  </li>

                  <li>
                    5.1.2.3. If the Company or substantially all of its assets are acquired by a third party, in which case personal data
                    will be one (1) of the transferred assets and the purchaser will be permitted to use the data for the
                    purposes for which it was originally collected by us.
                  </li>

                  <li>
                    5.1.2.4. If we’re under a duty to disclose or share your personal data in order to comply with any legal obligation,
                    enforce or apply our Terms & Conditions and other agreements, or to protect the rights, property, or safety
                    of the Company, our customers, or others (including exchanging information with other companies and
                    organisations for the purposes of fraud protection and credit risk reduction).
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            5.2. Parties with whom you may choose to share your information
            <ol>
              <li>
                5.2.1. You may choose to share any information or other content that you voluntarily submit to the Site or App
                either on public forums and public areas of the Site or App or within your private correspondences (meaning
                other users you have invited or accepted as members of your closed network). Such data will become available
                and viewable by other users as controlled by any applicable privacy settings that you define. To change your
                privacy settings on the Site or App, please tick or untick the relevant boxes in the personal account
                settings of your profile either on the website or App. Alternatively, you may contact us at
                enquiries@exsellance.com. Once you have shared your content or made it public, that content may be re-shared
                by others.
              </li>

              <li>
                5.2.2. If you choose to connect to social media networks from our Site or App or post any of your content on our
                Site or App to those networks, then in accordance with your social media privacy settings, the personal
                information that you post, transmit, or otherwise make available on the social media platform may be viewed
                and/or used by other users of those networks and we have no control over such viewing and use and cannot
                prevent further use of such information by third parties. When you interact with us through social media
                networks, you acknowledge that we may access your information that is held by that account, solely in
                accordance with your social media privacy settings. Any links to social media are not under our control and
                remain solely your responsibility. You acknowledge that any information posted via social media through our
                Site or App, or any third party you allow to access your content, is done entirely at your own risk and that
                by posting to a public platform you make that information visible to third-parties who can use that
                information at their discretion.
              </li>

              <li>
                5.2.3. You may review, modify, update, correct or remove any personal data you have submitted to the Site or App at
                any time. If you remove information that you posted to the Site or App, copies may remain viewable in cached
                and archived pages of the Site, or if other users or third party APIs have copied or saved that information.
              </li>

              <li>
                5.2.4. Always think carefully before disclosing personal data or other information to other users or otherwise
                posting personal data on the Site or App. It’s important that you’re aware that any data you choose to
                disclose on the Site or App may then be viewed and even used by other users (in accordance with your
                settings and this Privacy Policy). We do not control the contents of communications made between users
                (although you can make a complaint about another user by contacting us using the information provided in the
                Contact section below).
              </li>

              <li>
                5.2.5. You must respect the privacy of others and you must not disclose any personal details about other people
                including your family, friends, acquaintances, or other persons that may be misleading or cause them harm or
                offence. It is your responsibility to obtain their prior express permission in respect of any submission of
                their data at any time.
              </li>
            </ol>
          </li>
        </ol>

        <h5>6. International Transfers</h5>

        <ol>
          <li>
            6.1. The data that we collect from you may be transferred to, and stored on, google servers outside the European
            Economic Area (EEA). By submitting your personal data, you agree to this transfer, storing or processing. We
            will take all steps reasonably necessary to ensure that your data is treated as securely as it would be
            within the EEA and under the GDPR. Such steps may include our entering into contracts with any third parties
            we engage and the use of Commission-approved Model Contractual Clauses. In addition, we limit access to your
            personal data to those employees, agents, contractors and other third parties who have a business need to
            know. They will only process your personal data on our instructions and they are subject to a duty of
            confidentiality.
          </li>

          <li>
            6.2. You can obtain more details of the protection given to your personal data when it is transferred outside
            Europe (including a copy of the standard data protection clauses which we have entered into with recipients
            of your personal data) by contacting us as described in the Contact paragraph below.
          </li>
        </ol>

        <h5>7. Your Rights</h5>

        <ol>
          <li>
            7.1. Lawful Bases
            <ol>
              <li>
                7.1.1. We will ensure that your personal data is processed lawfully, fairly, and transparently and that it will
                only be processed if at least one (1) of the following bases applies:
                <ol>
                  <li>7.1.1.1. You have given your clear consent to the processing of your personal data for a specific purpose.</li>

                  <li>
                    7.1.1.2. Processing is necessary for the performance of a contract to which you are a party (or for us to take steps
                    at your request prior to entering into a contract with you).
                  </li>

                  <li>7.1.1.3. Processing is necessary for our compliance with the law.</li>

                  <li>7.1.1.4. Processing is necessary to protect someone’s life.</li>

                  <li>
                    7.1.1.5. Processing is necessary for us to perform a task in the public interest or in the exercise of official
                    authority and the task/function has a clear basis in law.
                  </li>

                  <li>
                    7.1.1.6. Processing is necessary for our legitimate interests or the legitimate interests of a third party, except
                    where there is a good reason to protect your personal data which overrides those legitimate interests, such
                    as allowing us to effectively and efficiently manage and administer the operation of our business,
                    maintaining compliance with internal policies and procedures, monitoring the use of our copyrighted
                    materials, offering optimal, up-to-date security and obtaining further knowledge of current threats to
                    network security in order to update our security.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            7.2. Data Subject Rights
            <ol>
              <li>
                7.2.1. Under the GDPR, you have the right to:
                <ol>
                  <li>
                    7.2.1.1. Withdraw your consent to the processing of your personal data at any time. Please note, however, that we may
                    still be entitled to process your personal data if we have another legitimate reason for doing so (such as
                    to comply with a legal obligation).
                  </li>

                  <li>7.2.1.2. Be informed of what data we hold and the purpose for processing the data, as a whole or in parts.</li>

                  <li>
                    7.2.1.3. Be forgotten and, in some circumstances, have your data erased by ourselves and our affiliates (although
                    this is not an absolute right and there may be circumstances where you ask us to erase your personal data
                    but we are legally entitled to retain it).
                  </li>

                  <li>7.2.1.4. Correct or supplement any information we hold about you that is incorrect or incomplete.</li>

                  <li>
                    7.2.1.5. Restrict processing of the information we hold about you (for example, so that inaccuracies may be
                    corrected—but again, there may be circumstances where you ask us to restrict processing of your personal
                    data but we are legally entitled to refuse that request).
                  </li>

                  <li>7.2.1.6. Object to the processing of your data.</li>

                  <li>7.2.1.7. Obtain your data in a portable manner and reuse the information we hold about you.</li>

                  <li>
                    7.2.1.8. hallenge any data we use for the purposes of automated decision-making and profiling (in certain
                    circumstances—as above, there may be circumstances where you ask us to restrict our processing of your
                    personal data but we are legally entitled to refuse that request).
                  </li>

                  <li>
                    7.2.1.9. Complain to a supervisory authority if you think any of your rights have been infringed by us. (We would,
                    however, appreciate the chance to address your concerns, so please contact us prior to taking this step).
                  </li>
                </ol>
              </li>

              <li>
                7.2.2. You will not have to pay a fee to access your personal data (or to exercise any of the other rights) unless
                your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your
                request in these circumstances.
              </li>

              <li>
                7.2.3. You have the right to ask us not to process your personal data for marketing purposes. We will get your
                express opt-in consent before we use your data for such purposes or share your personal data with any third
                parties for such purposes, but you can exercise your right to prevent such processing by contacting us at
                the Company Address, via email at enquiries@exsellance.com.
              </li>

              <li>
                7.2.4. You may revoke your consent for us to use your personal data as described in this Privacy Policy at any time
                by emailing us at enquiries@exselance.com, and we will delete your data from our systems. To enforce any of
                the above rights, please contact us at our Company Address or via email at enquiries@exsellance.com.
              </li>

              <li>
                7.2.5. We will notify you and any applicable regulator of a breach of your personal data when we are legally
                required to do so.
              </li>
            </ol>
          </li>
        </ol>

        <h4>Cookies</h4>

        <ol>
          <li>
            1. A cookie is a small file of letters and numbers that we store on your browser. Cookies contain
            information that is transferred to your computer's hard drive (or the hard drive of another relevant
            device). We use cookies to distinguish you from other users on the Site, to tailor your experience
            to your preferences, and to help us improve the Site.
          </li>
          <li>
            2. Some of the cookies we use are essential for the Site to operate. If you use your browser
            settings to block all cookies (including essential cookies), you may not be able to access all or
            parts of our Site.
          </li>
          <li>
            3. Before any non-essential cookies are placed on your device, you will be shown a pop-up message
            requesting your consent to setting those cookies. By default, most internet browsers accept cookies,
            but you can choose to enable or disable some or all cookies via the settings on your internet
            browser. Most internet browsers also enable you to choose whether you wish to disable all cookies or
            only third party cookies. For further details, please consult the help menu in your internet
            browser.
          </li>
          <li>
            4. We use the following cookies:
            <ol>
              <li>
                4.1. Strictly necessary cookies. These cookies are required to save your session and to
                carry out other activities that are strictly necessary for the operation of the Site. They
                include, by way of general example, cookies that enable you to log into secure areas of the
                Site, use a shopping cart, or make use of e-billing services. These cookies are session
                cookies, which means they’re temporary and will expire when you close your browser.
              </li>
              <li>
                4.2. Analytical/performance cookies. These cookies allow us to recognise and count the
                number of visitors and to see how visitors move around the Site when they’re using it. These
                cookies help us improve the way the Site works by, for example, ensuring that users are
                finding what they’re looking for easily.
              </li>
              <li>
                4.3. Functionality cookies. These cookies are used to recognise you when you return to the
                Site. They enable us to personalise our content for you, greet you by name and remember your
                preferences.
              </li>
              <li>
                4.4. Targeting cookies. These cookies record your visit to the Site, the pages you visit,
                and the links you follow. We use this information to make the Site and the advertising
                displayed on it more relevant to your interests. We also share this information with third
                parties for the same purpose.
              </li>
              <li>
                4.5. Social Media cookies. These cookies work together with social media plug-ins. For
                example, when we embed photos, video and other content from social media websites, the
                embedded pages contain cookies from these websites. Similarly, if you choose to share our
                content on social media, a cookie may be set by the service you have chosen to share content
                through.
              </li>
              <li>
                4.6. Third Party cookies. We use third party cookies on the Site. Please note that we do not
                control cookies placed by third parties and our Site does not block them. Please check the
                relevant third-party website for more information about these cookies.
              </li>
            </ol>
          </li>
          <li>
            You have the right to opt out of social media cookies and third-party cookies and to object
            to automated profiling. To enforce either of these rights please contact us at
            enquiries@exsellance.com.
          </li>
        </ol>______________________________________________________________________________________
        <p>
          Changes To Our Privacy & Cookie Policies Any changes we may make to our Privacy & Cookie Policies in the
          future will be posted on this page and, where appropriate, notified to you by email. You will be deemed
          to have accepted the terms of the updated Privacy & Cookie Policies on your first use of the Site or App
          following the alterations. Please check back frequently to see any updates or changes to our Privacy &
          Cookie Policies.
        </p>

        <p>
          Contact Questions, comments and requests regarding this Privacy & Cookie Policy are welcomed and should
          be addressed to our Company Address or to our email at enquiries@exsellance.com.
        </p>
      </mdb-modal-body>
      <mdb-modal-footer></mdb-modal-footer>
    </mdb-modal>
  </div>
</template>
<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbInput,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";

import firebase from "firebase";
import { statsMixin } from "../mixins/StatsMixin";
import { store } from "../store";

export default {
  name: "register",
  mixins: [statsMixin],
  data() {
    return {
      email: "",
      password: "",
      validationMessage: "",
      showModal: false,
      showModal1: false,
      showModal2: false,
      showWarning: false,
      accepted: false
    };
  },
  methods: {
    mthInitLocalstoreData() {
      this.$store.commit("setAssessmentIdParam", null);
      this.$store.commit("setUserhasfilledhisassessment", false);
      this.$store.commit("setIamtheboss", null);
      this.$store.commit("setAvatarurl", "");
      this.$store.commit("setNickname", "");
    },
    mthStatsIncrementNewUsers() {
      this.mthMixinStatsIncrementNewUsers();
    },
    mthFillProfileData(user) {
      //console.log("mthFillProfileData: user is ");

      //console.log(user);

      firebase
        .firestore()
        .collection("usersProfiles")
        .doc(this.email)
        .set({
          joinedDate: new Date()
        });
    },
    signup: function() {
      //signup button

      if (this.accepted === true) {
        var self = this;

        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(
            function(user) {
              self.validationMessage = "Your account has been created.";

              self.mthFillProfileData(user);

              //self.$router.replace("/");
            },
            function(err) {
              self.validationMessage = err.message;
              alert(err);
            }
          );

        this.mthStatsIncrementNewUsers();

        this.mthInitLocalstoreData(); //clear existing values from previous user
      } else {
        this.showWarning = true;
      }
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      //console.log("onAuthStateChanged fired!");
      if (user) {
        this.$router.replace("/");
      }
    });
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
  }
};
</script>

<style>
</style>
